import {
  CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_BEGIN,
  CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_SUCCESS,
  CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_FAILURE,
  CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCustomFunctionConfig(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/custom-function`,
        header,
      );

      doRequest.then(
        (res) => {
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCustomFunctionConfigError() {
  return {
    type: CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_BEGIN:
      return {
        ...state,
        loadCustomFunctionConfigPending: true,
        loadCustomFunctionConfigError: null,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_SUCCESS:
      return {
        ...state,
        loadCustomFunctionConfigPending: false,
        loadCustomFunctionConfigError: null,
        customFunctions: action.data,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_FAILURE:
      return {
        ...state,
        loadCustomFunctionConfigPending: false,
        loadCustomFunctionConfigError: action.data.error,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_DISMISS_ERROR:
      return {
        ...state,
        loadCustomFunctionConfigError: null,
      };

    default:
      return state;
  }
}
